import { getToday } from 'utils/shiftedDateTime';
import { LatestLoan } from 'hooks/webapi/useLatestLoan';
import { useLatestLoan } from 'hooks/webapi';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';

const SELEKTRA_LOAN_STORAGE_KEY = 'selektraFormLoan';
const SELEKTRA_SKIP_KEY = 'selektraSkip';
const SELEKTRA_VISITED_DATE_KEY = 'SelektraVisitedDate';
const SELEKTRA_VISITED_DATE_EXPIRY_WEEKS = 7;
const SELEKTRA_MAX_DAYS_LOAN = 21;

const useSelektra = () => {
  const { latestLoan } = useLatestLoan();

  const saveSelektraLoan = () => {
    if (latestLoan?.loanNumber)
      localStorage.setItem(SELEKTRA_LOAN_STORAGE_KEY, latestLoan?.loanNumber);
  };

  const saveSelektraVisitedDate = () => {
    Cookies.set(SELEKTRA_VISITED_DATE_KEY, 'true', {
      expires: SELEKTRA_VISITED_DATE_EXPIRY_WEEKS * 7,
    });
  };

  const shouldClientVisitSelektraPage = () => {
    return !Cookies.get(SELEKTRA_VISITED_DATE_KEY);
  };

  const skipSelektraPageInThisSession = () => {
    sessionStorage.setItem(SELEKTRA_SKIP_KEY, 'true');
  };

  const selektraLoanNumber = localStorage.getItem(SELEKTRA_LOAN_STORAGE_KEY);

  const isSelektraVisitedByLoan = (
    fetchedLatestLoan?: LatestLoan | null | undefined,
  ) => {
    const loanToCheck = fetchedLatestLoan || latestLoan;
    return loanToCheck && loanToCheck.loanNumber === selektraLoanNumber;
  };

  const skipSelectraPageInThisSession =
    sessionStorage.getItem(SELEKTRA_SKIP_KEY) === 'true';

  const getIsSelektraAvailable = (
    fetchedLatestLoan?: LatestLoan | null | undefined,
  ) => {
    const loanToCheck = fetchedLatestLoan || latestLoan;

    const loanTooOldBySelektra =
      loanToCheck?.startDate &&
      dayjs(getToday()).diff(dayjs(loanToCheck.startDate), 'day') >
        SELEKTRA_MAX_DAYS_LOAN;

    return Boolean(
      loanToCheck &&
        !loanToCheck?.overDueDays &&
        !loanTooOldBySelektra &&
        !isSelektraVisitedByLoan() &&
        !skipSelectraPageInThisSession,
    );
  };

  const isSelektraAvailable = getIsSelektraAvailable();

  const isSelektraPageRequired = (
    fetchedLatestLoan?: LatestLoan | null | undefined,
  ) => {
    const isSelektraAvailable = getIsSelektraAvailable(fetchedLatestLoan);

    return isSelektraAvailable && shouldClientVisitSelektraPage();
  };

  const clearSelektra = () => {
    localStorage.removeItem(SELEKTRA_LOAN_STORAGE_KEY);
    sessionStorage.removeItem(SELEKTRA_SKIP_KEY);
    Cookies.remove(SELEKTRA_VISITED_DATE_KEY);
  };

  return {
    clearSelektra,
    isSelektraAvailable,
    isSelektraPageRequired,
    saveSelektraLoan,
    saveSelektraVisitedDate,
    skipSelektraPageInThisSession,
  };
};

export default useSelektra;
